import { Injectable, Injector } from '@angular/core';
import { isDefined } from '@fi-shared/utils/is-defined';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { WidgetRegisterService } from './widget-register.service';
import { comparator } from '@fi-shared/utils/array-sort-comparators';
import { IWidgetContentModel, WidgetContentModel } from './model/widget-content.model';
import { IDocumentListingItem } from '@fi-shared/widget/document-listing/document-listing-base';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { ModuleType, ObjectTypes } from '@fi-shared/types';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Injectable()
export class WidgetService {
    constructor(
        private injector: Injector,
        private fiBackend: FiBackendService,
        private widgetRegisterService: WidgetRegisterService,
        private contentLanguagesService: ContentLanguagesService,
        private userDataService: FiUserDataService,
        private fiFormatDateService: FiFormatDateService,
    ) {}

    createWidget(contentLanguages, item) {
        const widgetPrototype = this.widgetRegisterService.getWidgetPrototype(
            contentLanguages,
            JSON.parse(item.Settings).Name,
        );
        return new widgetPrototype(contentLanguages, this.fiFormatDateService, item);
    }

    getWidgets(
        objectType,
        args?: {
            loadContents?: boolean;
            isEditMode?: boolean;
            siteDesignId?: number;
        },
    ) {
        if (!args) {
            args = {};
        }
        if (!isDefined(args.loadContents)) {
            args.loadContents = true;
        }
        if (!args.siteDesignId) {
            args.siteDesignId = this.userDataService.getActiveSiteDesignId();
        }

        const promise = new Promise<WidgetModel[]>((resolve, reject) => {
            const widgets: WidgetModel[] = [];

            let url = `Widget/Widget/GetWidgets/${objectType}/${args.loadContents}/${!args.isEditMode}?siteDesignId=${args.siteDesignId}`;
            this.fiBackend.fetchData<any[]>(url).then((response) => {
                response.forEach((item) => {
                    widgets.push(this.createWidget(this.contentLanguagesService.GetContentLanguages(), item));
                });
                // sort widgets;
                const sortedWidgets = widgets.sort(
                    comparator((widget) => this.widgetRegisterService.getWidgetSortOrder(widget.Settings.Name)),
                );
                resolve(sortedWidgets);
            }, reject);
        });

        return promise;
    }

    saveWidget(widgetItem, siteDesignId: number) {
        //Creating a new object because it looks bad in the GUI otherwise.
        const widgetApiModel = JSON.parse(JSON.stringify(widgetItem));
        return this.fiBackend.fetchDataPost(`Widget/Widget/SaveWidgetModuleContents/${siteDesignId}`, widgetApiModel);
    }

    DeleteWidgetContent(widgetIds: number[]) {
        return this.fiBackend.fetchDataPost('Widget/Widget/DeleteWidgetModuleContents', widgetIds);
    }

    GetWidgetNameTextIds() {
        return this.fiBackend.fetchData('Widget/Widget/GetWidgetNameTextIds');
    }

    GetWidgetModuleContents(moduleType: ModuleType, objectId: number, objectType: ObjectTypes, siteDesignId: number) {
        const promise = new Promise<WidgetContentModel[]>((resolve, reject) => {
            const widgets: WidgetContentModel[] = [];

            this.fiBackend
                .fetchData<
                    IWidgetContentModel[]
                >(`Widget/Widget/GetWidgetModuleContents/${moduleType}?siteDesignId=${siteDesignId}`)
                .then((response) => {
                    response.forEach((item) => {
                        const widget = new WidgetContentModel(this.contentLanguagesService.GetContentLanguages(), item);
                        widget.objectId = objectId;
                        widget.objectType = objectType;
                        widgets.push(widget);
                    });
                    resolve(widgets);
                }, reject);
        });

        return promise;
    }
}
